import { all, call, put, takeEvery } from 'redux-saga/effects';

import { FETCH_ORDER_SUMMARY_REQUESTS, retrieveOrderStatus, setAPIFinished, triggerAnalytics } from '../actions';
import { deliveryDetailsRequest } from './requests/deliveryDetails';
import { orderSummaryRequest } from './requests/orderSummary';

export function* orderSummary(): Generator {
  yield all([call(orderSummaryRequest), call(deliveryDetailsRequest)]);

  yield put(retrieveOrderStatus());
  yield put(setAPIFinished());
  yield put(triggerAnalytics());
}

export function* watchOrderSummary(): Generator {
  yield takeEvery(FETCH_ORDER_SUMMARY_REQUESTS, orderSummary);
}
